import { ElMessage } from 'element-plus'

const DEFAULTS = {
  duration: 3200,
  offset: 24,
  showClose: true,
  customClass: 'al-toast',
  grouping: true
}

function show(type, message, options = {}) {
  const text = String(message || '').trim() || (type === 'success' ? '操作成功' : '操作失败')
  return ElMessage({
    type,
    message: text,
    ...DEFAULTS,
    ...options,
    customClass: ['al-toast', `al-toast--${type}`, options.customClass].filter(Boolean).join(' ')
  })
}

export const toast = {
  success(message, options) {
    return show('success', message, options)
  },
  warning(message, options) {
    return show('warning', message, options)
  },
  info(message, options) {
    return show('info', message, options)
  },
  error(message, options) {
    return show('error', message, { duration: 4200, ...options })
  },
  closeAll() {
    ElMessage.closeAll()
  }
}

export default toast
